<template>
  <div>
    <div class="row">
      <div
        class="col-xs-3"
        v-for="db in Object.keys(databases)"
      >
        <CardStatusReplication
          :database="db"
          :label="databases[db]"
        ></CardStatusReplication>
      </div>
    </div>
  </div>
</template>

<script>
  import CardStatusReplication from '../../components/Trg/StatusReplications/CardStatusReplication'

  export default {
    name: 'IndexStatusReplication',
    components: {
      CardStatusReplication
    },
    data () {
      return {
        databases: {
          'default': 'Geral',
          'specifications': 'Especificações',
          'winners': 'Contemplados',
          'docs': 'Documentação',
          'logs': 'Logs',
          'surveys': 'Pesquisas',
          'surveys_docs': 'Documentação das pesquisas',
          'config': 'Configurações'
        },
        remote_database: {
          'remote_default': 'Remoto: Geral',
          'remote_specifications': 'Remoto: Especificações',
          'remote_winners': 'Remoto: Contemplados',
          'remote_docs': 'Remoto: Documentação',
          'remote_logs': 'Remoto: Logs',
          'remote_surveys': 'Remoto: Pesquisas',
          'remote_surveys_docs': 'Remoto: Documentação das pesquisas',
          'remote_config': 'Remoto: Configurações'
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/StatusReplication/IndexStatusReplication.vue